import { Entity } from "@/app/common/base/entity"
import { Expose } from "class-transformer"

export class PasswordStrength extends Entity<PasswordStrength> {

    @Expose({ name: 'minimum_password_strength' })
    score!: number

}
